module.exports = __webpack_public_path__ + "e933c6c3a6bb4417a80cd90f157ecda7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-1.png
// module id = 2088
// module chunks = 0